import { HookHttpDownloadBlob } from 'Hook'
import { TypeNav, TypeNavControlDownloadBlob } from 'Type'


const HookNavDownloadBlob = (nav? :TypeNav<any>) :TypeNavControlDownloadBlob => {
    return HookHttpDownloadBlob(nav?.path)

}

export default HookNavDownloadBlob